// @material-ui/icons
import Dashboard from "@material-ui/icons/Dashboard";
// import Person from "@material-ui/icons/Person";
// import ContentPaste from "@material-ui/icons/ContentPaste";
// import LibraryBooks from "@material-ui/icons/LibraryBooks";
// import BubbleChart from "@material-ui/icons/BubbleChart";
// import LocationOn from "@material-ui/icons/LocationOn";
// import Notifications from "@material-ui/icons/Notifications";
// import Unarchive from "@material-ui/icons/Unarchive";
// core components/views
import DashboardPage from "views/Dashboard/Dashboard.jsx";
// import UserProfile from "views/UserProfile/UserProfile.jsx";
import TableList from "views/TableList/TableList.jsx";
import Addcustomer from "../views/Addcustomer/Addcustomer.jsx";
import ApproveUser from "../views/ApproveUser/ApproveUser.jsx";
import UserProfile from "../views/UserProfile/UserProfile.jsx";
import RequestPermission from "../views/RequestPermission/RequestPermossion.jsx";
// import Login from "../layouts/Login/Login.jsx";
// import Register from "../views/Register/Register.jsx";
// import Typography from "views/Typography/Typography.jsx";
// import Icons from "views/Icons/Icons.jsx";
// import Maps from "views/Maps/Maps.jsx";
import NotificationsPage from "../views/Notification/Notifications.jsx";
// import UpgradeToPro from "views/UpgradeToPro/UpgradeToPro.jsx";
let dashboardRoutes = [];
if (localStorage.getItem("data") !== null) {
  if (JSON.parse(localStorage.getItem("data")).ACTIVE === "Y") {
    dashboardRoutes.push(
      {
        path: "/dashboard",
        sidebarName: "หน้าแรก",
        navbarName: "หน้าแรก",
        icon: Dashboard,
        component: DashboardPage,
        show: true
      },
      {
        path: "/tables",
        sidebarName: "ตารางงาน",
        navbarName: "ตารางงาน",
        icon: "content_paste",
        component: TableList,
        show: true
      },
      {
        path: "/addcustomer",
        sidebarName: "เพิ่มข้อมูลลูกค้าใหม่",
        navbarName: "เพิ่มข้อมูลลูกค้าใหม่",
        icon: "group_add",
        component: Addcustomer,
        show: false
      },
      {
        path: "/userprofile",
        sidebarName: "โปรไฟล์",
        navbarName: "โปรไฟล์",
        icon: "done",
        component: UserProfile,
        show: false
      },
      {
        path: "/notification",
        sidebarName: "แจ้งเตือน",
        navbarName: "แจ้งเตือน",
        icon: "warning",
        component: NotificationsPage,
        show: true
      }
    );
  } else {
    if (window.location.href.indexOf("/requestpermission") === -1)
      window.location.assign("/requestpermission");
  }
  if (JSON.parse(localStorage.getItem("data")).ACTIVE === "W") {
    dashboardRoutes.push({
      path: "/requestpermission",
      sidebarName: "ขอสิทธิ์ผู้ใช้งาน",
      navbarName: "ขอสิทธิ์ผู้ใช้งาน",
      icon: "people",
      component: RequestPermission,
      show: true
    });
  }
  dashboardRoutes.push({
    path: "/approveuser",
    sidebarName: "อนุมัติบัญชีผู้ใช้งาน",
    navbarName: "อนุมัติบัญชีผู้ใช้งาน",
    icon: "group_add",
    component: ApproveUser,
    show: true
  });

  if (
    JSON.parse(localStorage.getItem("data")).acstatus !== "4" &&
    JSON.parse(localStorage.getItem("data")).acstatus !== "1" &&
    JSON.parse(localStorage.getItem("data")).ACTIVE === "Y"
  ) {
    // dashboardRoutes.push({
    //   path: "/approveuser",
    //   sidebarName: "อนุมัติบัญชีผู้ใช้งาน",
    //   navbarName: "อนุมัติบัญชีผู้ใช้งาน",
    //   icon: "group_add",
    //   component: ApproveUser,
    //   show: true
    // });
  }
} else {
  
  if (
    window.location.href !== "http://localhost:3000/" &&
    window.location.href !== "https://panelmunkongcvm.one.th/" &&
    window.location.href.indexOf("192.168") === -1 &&
    window.location.href.indexOf("http://localhost:3000/webview")>-1 &&
    window.location.href.indexOf("https://panelmunkongcvm.one.th/webview")>-1 &&
    window.location.href.indexOf("http://localhost:3000/webviewsale")>-1 && 
    window.location.href.indexOf("https://panelmunkongcvm.one.th/webviewsale") >-1
  )
    window.location.assign("/");
}

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/dashboard.jsx